import { render, staticRenderFns } from "./DriverWallet.vue?vue&type=template&id=811cd438&"
import script from "./DriverWallet.vue?vue&type=script&lang=js&"
export * from "./DriverWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports